import React from 'react';
import loadable from '@loadable/component';
import productComparePageQuery from './query.graphql';

const ProductComparePage = loadable(() =>
  import(/* webpackChunkName: "product-compare" */ './product-compare')
);

const ProductCompare = () => {
  return <ProductComparePage />;
};

ProductCompare.MAX_PRODUCTS = 40;

ProductCompare.graphQL = productComparePageQuery;

ProductCompare.variables = ({ categoryId, productIds }) => ({
  categoryId: categoryId || 0,
  fetchCategory: !!categoryId,
  productIds:
    typeof productIds !== 'string'
      ? []
      : productIds
          .split(',')
          .map(item => parseInt(item, 10))
          .filter((id, index, arr) => !isNaN(id) && arr.indexOf(id) === index) // only keep unique, valid integers
          .slice(0, ProductCompare.MAX_PRODUCTS),
});

export default ProductCompare;
